/**
 * Vault PWA boot (L1), shared by every build. Recomposes the lanes at integration: the shell owns
 * state and routing, and every screen comes from its lane module.
 *
 * This module chooses nothing. Each build has its own entry in src/entry/ that picks the data
 * source and the unlocker and calls `boot` (CSO review of PR #95), so the placeholder unlocker,
 * the fixture data and the `?unlock=` / `?fixture=` review hooks exist only in the fixture build.
 */
import { startApp, type AppOptions } from "./shell/app.js";

declare const __VAULT_VERSION__: string;

export function boot(wiring: Omit<AppOptions, "version" | "clock" | "clipboard">): void {
  startApp(document.getElementById("app")!, {
    ...wiring,
    version: typeof __VAULT_VERSION__ === "string" ? __VAULT_VERSION__ : "dev",
  });

  if ("serviceWorker" in navigator && location.protocol !== "file:") {
    navigator.serviceWorker.register("sw.js").catch(() => {
      /* Offline shell is a convenience; the app works without it. */
    });
  }
}
